export const contactsData = {
    email: 'haidermaaz29@gmail.com',
    phone: '+92 307 8606369',
    address: 'Faisalabad, Punjab, Pakistan',

    sheetAPI: ''
}